<div class="imageStage">
    <div *ngIf="productInfo.country" class="hero-flag-corner">
      <flag [country]="productInfo.country"></flag>
    </div>
    <div class="content" fxLayout="row" fxLayout.lt-sm="column" ngClass.lt-sm="small">
      <div class="image" fxFlex="200px">
        <img [src]="getProductImage(productInfo.imageUrl, productInfo.productName)">
      </div>
      <div class="text">
        <h1 *ngIf="productInfo.productName" ngClass.lt-sm="small">
          {{ productInfo.productName }}</h1>
        <h1 *ngIf="!productInfo.productName" ngClass.lt-sm="small">
          {{ productInfo.description }}</h1>
        <table class="product-specs">
          <tr *ngIf="productInfo.productType">
            <td class="spec-label">{{ 'hero.product-type' | translate }}</td>
            <td class="spec-value">{{ productInfo.productType }}</td>
          </tr>
          <tr *ngIf="productInfo.country">
            <td class="spec-label">{{ 'hero.country' | translate }}</td>
            <td class="spec-value">{{ getCountryName(productInfo.country) }}</td>
          </tr>
          <tr>
            <td class="spec-label">{{ 'hero.serial-number' | translate }}</td>
            <td class="spec-value">{{ productInfo.number }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <div class="content" style="margin-top: 24px; padding-bottom: 40px;">
    <div *ngIf="staticLinkBoxes.length <= 2" class="tiles md-padding flex-container">
      <div *ngFor="let staticLinkBox of staticLinkBoxes" class="tile flex-item" style="width: 100%;">
        <a class="tile-card" href="{{buildLink(staticLinkBox.link, productInfo.number)}}" target="_blank">
          <div [style.backgroundImage]="'url(' + getImage(staticLinkBox.type) + ')'" [class]="'tile-image large ' + staticLinkBox.type.toLowerCase()"></div>
          <div class="tile-text">
            <span class="tile-headline">{{staticLinkBox.textKey | translate}}</span>
            <span class="tile-cta"><span class="tile-cta-text">{{ getCTAKey(staticLinkBox.type) | translate }}</span><svg class="tile-cta-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6 20.212 7.82 22 18 12 7.82 2 6 3.788 14.36 12z"></path></svg></span>
          </div>
        </a>
      </div>
    </div>

    <div *ngIf="staticLinkBoxes.length > 2" class="tiles md-padding flex-container">
      <div *ngFor="let staticLinkBox of staticLinkBoxes" class="tile flex-item"
           style="flex: 1 1 100%; flex-basis: 100%; flex-basis: calc(25% - 10px); min-width: 300px;">
        <a class="tile-card" href="{{buildLink(staticLinkBox.link, productInfo.number)}}" target="_blank">
          <div [style.backgroundImage]="'url(' + getImage(staticLinkBox.type) + ')'" [class]="'tile-image ' + staticLinkBox.type.toLowerCase()"></div>
          <div class="tile-text">
            <span class="tile-headline">{{staticLinkBox.textKey | translate}}</span>
            <span class="tile-cta"><span class="tile-cta-text">{{ getCTAKey(staticLinkBox.type) | translate }}</span><svg class="tile-cta-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6 20.212 7.82 22 18 12 7.82 2 6 3.788 14.36 12z"></path></svg></span>
          </div>
        </a>
      </div>
    </div>
  </div>


